import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../../apiClient';
import { User } from '../../users';

export interface FormResponseUser {
    _id: string;
    responseId: string;
    userId?: string;
    name?: string;
    contractType: number;
    hasValidatedPresence: boolean;
    validatedAt?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface FormResponseUserResponse {
    message: string;
    data: FormResponseUser;
}

export interface FormResponseUsersResponse {
    message: string;
    data: FormResponseUser[];
}

export interface FormResponseUserWithDetails extends Omit<FormResponseUser, 'userId'> {
    userId?: User;
}

export interface FormResponseUsersWithDetailsResponse {
    message: string;
    data: FormResponseUserWithDetails[];
}

export const getAttendedUsersByResponseId = async (responseId: string): Promise<FormResponseUsersWithDetailsResponse> => {
    try {
        const response: AxiosResponse<FormResponseUsersWithDetailsResponse> = await apiClient.get(`/form-response-users/${responseId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
